<template>
  <div class="jksb_content">
    <el-row
      type="flex"
      justify="space-around"
      style="width: 100%; height: 100%"
    >
      <el-col :span="12">
        <div class="zlgl_title"><span>每日合格率</span></div>
        <div
          id="chart01"
          ref="chartRefLine1"
          style="width: 100%; height: 80%"
        ></div>
      </el-col>
      <el-col :span="12">
        <div class="zlgl_title"><span>每日生产效率</span></div>
        <div
          id="chart02"
          ref="chartRefLine2"
          style="width: 100%; height: 80%"
        ></div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import { getRecordRate, getTaskRate } from '@/api/index'
export default {
  data () {
    return {
      rateList1: [],
      rateList2: [],
    }
  },
  mounted () {
    this.getRecordRates();
    this.getTaskRates();
  },
  methods: {
    setOpenCloseCharts1 () {
      const theEcharts1 = echarts.init(this.$refs.chartRefLine1, 'dark');

      const options1 = {
        grid: {
          left: '0%',    // 去除左侧间距
          right: '0%',   // 去除右侧间距
          bottom: '0%',  // 去除底部间距
          top: '10%',     // 去除顶部间距
          containLabel: true // 如果使用 `containLabel: true`，则会根据标签大小自动调整间距，保证标签内容不被裁剪
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        xAxis: {
          type: 'category',
          data: this.rateList1.map(item => item.recordDate)
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: 100,
          interval: 20,
          axisLabel: {
            formatter: '{value}%'
          }
        },
        series: [
          {
            data: this.rateList1.map(item => item.qualifiedPercent),
            type: 'line',
            areaStyle: {
              opacity: 0.3
            }
          }
        ]
      }

      // 渲染图表
      theEcharts1.setOption(options1)
    },
    setOpenCloseCharts2 () {
      const theEcharts2 = echarts.init(this.$refs.chartRefLine2, 'dark');
      const options2 = {
        grid: {
          left: '0%',    // 去除左侧间距
          right: '0%',   // 去除右侧间距
          bottom: '0%',  // 去除底部间距
          top: '10%',     // 去除顶部间距
          containLabel: true // 如果使用 `containLabel: true`，则会根据标签大小自动调整间距，保证标签内容不被裁剪
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        xAxis: {
          type: 'category',
          data: this.rateList2.map(item => item.recordDate)
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: 100,
          interval: 20,
          axisLabel: {
            formatter: '{value}%'
          }
        },
        series: [
          {
            data: this.rateList2.map(item => item.completionRate),
            type: 'line',
            areaStyle: {
              opacity: 0.3
            }
          }
        ]
      }
      theEcharts2.setOption(options2)
    },
    async getRecordRates () {
      let result = await getRecordRate({})
      console.log(result)
      if (result.code == 200) {
        this.$set(this, 'rateList1', result.data)
        this.setOpenCloseCharts1()
      }
    },
    async getTaskRates () {
      let result = await getTaskRate({})
      console.log(result)
      if (result.code == 200) {
        this.$set(this, 'rateList2', result.data)
        this.setOpenCloseCharts2()
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.jksb_content {
  width: 100%;
  height: 100%;
  display: flex;
  align-content: space-between;
  .zlgl_title {
    width: 100%;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    text-align: left;
    padding-bottom: 5px;
    margin-top: 10px;
  }
}
</style>